/* eslint-disable react/prop-types */
import { CheckIconModal } from '../CheckIconModal'

const DefaultDescription = () => (
  <>
    Sua campanha já está baixando, pronta para publicar.
    <br />
    <br />
    E as 10 artes do pacote já estão na sua conta para as próximas criações.
  </>
)

export const PaymentSuccessModal = ({
  isOpen,
  onClose,
  title = 'Pagamento confirmado!',
  description,
  primaryAction,
  secondaryAction,
  showCloseButton = true,
  showCheckIcon = true,
}) => {
  return (
    <CheckIconModal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      titleId="payment-success-modal-title"
      description={description ?? <DefaultDescription />}
      primaryAction={primaryAction}
      secondaryAction={secondaryAction}
      showCloseButton={showCloseButton}
      showCheckIcon={showCheckIcon}
    />
  )
}

export default PaymentSuccessModal
